export function handleErrorGraphQLMessage(error) {
  let message = 'An error has occurred, please contact the admin!';
  if (typeof error === 'string') {
    return error;
  }
  const { errors } = error;
  if (errors && errors.length > 0) {
    message = errors[0]?.message || message;
  } else if (error && error.length > 0) {
    message = error[0]?.message || message;
  }
  return message;
}
